/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { Pressable } from "react-native";

import { Text } from "UpduoLibrary";
import { skaleBlack, upduoLightestGray } from "config/UpduoColors";

interface KudosChoiceButtonProps {
  title: string;
  iconContent: React.ReactNode;
  color: string;
  isSelected: boolean;
  _handleKudosChoicePress: () => void;
}
export default function KudosChoiceButton({
  title,
  iconContent,
  color,
  isSelected,
  _handleKudosChoicePress,
}: KudosChoiceButtonProps) {
  return (
    <Pressable
      onPress={() => {
        _handleKudosChoicePress();
      }}
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: isSelected ? color : upduoLightestGray,
        borderRadius: 4,
        paddingHorizontal: 6,
        paddingVertical: 6,
        marginRight: 9,
        marginBottom: 8,
      }}
    >
      {iconContent}
      <Text
        style={{
          color: skaleBlack,
          marginLeft: 4,
          fontWeight: "500",
          alignSelf: "center",
        }}
      >
        {title}
      </Text>
    </Pressable>
  );
}
